document.addEventListener('DOMContentLoaded', initTrackOrderFormHandler);

function getStatusFromChangeDates(statusChangeDates) {
    if (!statusChangeDates) {
        return '';
    }
    const statusPriority = ['90', '2', '3', '80', '70', '60', '20', '1', '95', '96', '97', '98', '81', '92'];
    for (const statusCode of statusPriority) {
        if (statusChangeDates[statusCode]) {
            return statusCode;
        }
    }
    return '';
}

function getStatusText(statusValue) {
    const statusTranslations = {
        '1': 'פתוח',
        '2': 'פתוח',
        '3': '',
        '20': 'בליקוט',
        '60': 'נסגר חלקי',
        '61': 'Translation missing: he-IL.customer.orders.status.61',
        '62': 'Translation missing: he-IL.customer.orders.status.62',
        '70': 'נסגר מלא',
        '80': 'נמסרה למשלח',
        '81': '',
        '90': 'נמסרה ללקוח',
        '92': 'נאסף מסניף',
        '95': 'בקשה לביטול',
        '96': 'בוטל - אין במלאי',
        '97': 'בוטל - לקוח',
        '98': 'לא ניתן לבטל'
    };
    return statusTranslations[statusValue] || '';
}

function getPizzabarCurrentStep(statusCode, isPickup) {
    const order_received = ['1', '2', '3', '20'];
    const order_packed = ['60', '61', '62', '70'];
    const out_for_delivery = ['80', '81'];
    const shipment_arrived_store = ['92'];
    const delivered_to_customer = ['90'];

    const code = statusCode ? statusCode.toString() : '';
    let current_step = 1;
    if (order_received.includes(code)) {
        current_step = 1;
    } else if (order_packed.includes(code)) {
        current_step = 2;
    } else if (out_for_delivery.includes(code)) {
        current_step = 3;
    } else if (shipment_arrived_store.includes(code) && isPickup) {
        current_step = 4;
    } else if (shipment_arrived_store.includes(code)) {
        current_step = 3;
    } else if (delivered_to_customer.includes(code) && isPickup) {
        current_step = 5;
    } else if (delivered_to_customer.includes(code)) {
        current_step = 4;
    }

    return current_step;
}

function formatOrderDate(orderDate) {
    if (!orderDate) {return ''};

    const date = new Date(orderDate);

    return date.toLocaleDateString('he-IL', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric'
    });
}

function formatOrderTotal(totalAmount) {
    if (totalAmount === undefined || totalAmount === null) {
        return '';
    }

    const freeText = 'Translation missing: he-IL.products.product.free';
    const amount = parseFloat(totalAmount);

    if (Number.isNaN(amount)) {
        return '';
    }

    return amount === 0
        ? freeText
        : `₪ ${amount.toFixed(2)}`;
}

function buildOrderRow(responseJson, orderName) {
    const orderTableWrapper = document.getElementById('track-order-table-wrapper');
    if (!orderTableWrapper) {
        return;
    }

    orderTableWrapper.innerHTML = '';

    const orderTableTemplate = document.getElementById('order-table-template');
    if (!orderTableTemplate || !orderTableTemplate.content) {
        return;
    }

    const orderTableClone = orderTableTemplate.content.cloneNode(true);
    const orderRows = orderTableClone.querySelectorAll('.boa-order-row');

    if (!orderRows || orderRows.length === 0) {
        return;
    }

    const inProcessText = 'בתהליך עיבוד';

    // Status
    const statusValue = responseJson.status
        ? responseJson.status.toString()
        : getStatusFromChangeDates(responseJson.statusChangeDates);

    const statusText = statusValue ? getStatusText(statusValue) : '';

    // Populate both desktop and mobile versions
    orderRows.forEach((orderRow) => {
        const orderNameCell = orderRow.querySelector('.boa-row-name');
        const orderDateCell = orderRow.querySelector('.boa-row-date');
        const orderCountCell = orderRow.querySelector('.boa-row-count');
        const orderTotalCell = orderRow.querySelector('.boa-row-total');
        const orderStatusCell = orderRow.querySelector('.boa-row-status');

        if (!orderNameCell || !orderTotalCell || !orderStatusCell) {
            return;
        }

        // Name
        orderNameCell.textContent = orderName || '';

        // Date
        if (orderDateCell && responseJson.orderDate) {
            orderDateCell.textContent = formatOrderDate(responseJson.orderDate);
        }

        // Item count
        if (orderCountCell) {
            orderCountCell.textContent = responseJson.totalItemCount?.toString() || '0';
        }

        // Total
        if (orderTotalCell) {
            orderTotalCell.textContent = formatOrderTotal(responseJson.totalAmount);
        }

        // Status
        orderStatusCell.textContent = statusText || inProcessText;
    });

    orderTableWrapper.appendChild(orderTableClone);

    return statusValue;
}

function updatePizzabar(statusValue, isPickup) {
    const pizzabar = document.querySelector('.boa-track-order-section .boa-pizzabar');

    if (!pizzabar || !statusValue) {
        return;
    }

    const lastStepLine = pizzabar.querySelector('.pizzabar-line.last-step-pickup');
    const lastStep = pizzabar.querySelector('.pizzabar-step.last-step-pickup');

    const current = getPizzabarCurrentStep(statusValue, isPickup);

    pizzabar.setAttribute('data-status', statusValue);
    pizzabar.setAttribute('data-current', current.toString());
    pizzabar.setAttribute('data-is-pickup', isPickup ? 'true' : 'false');

    if (isPickup) {
        const pickupStep4Title = pizzabar.querySelector('.pizzabar-step.pizzabar-4 .step-title.pickup');
        if (pickupStep4Title) {
            pickupStep4Title.classList.remove('hidden');
        }

        lastStepLine.classList.remove('hidden');
        lastStep.classList.remove('hidden');

        const lastStepDeliveryTitle = pizzabar.querySelector('.pizzabar-step.last-step-pickup .step-title.delivery');
        if (lastStepDeliveryTitle) {
            lastStepDeliveryTitle.classList.remove('hidden');
        }
    } else {
        const deliveryStep4Title = pizzabar.querySelector('.pizzabar-step.pizzabar-4 .step-title.delivery');
        if (deliveryStep4Title) {
            deliveryStep4Title.classList.remove('hidden');
        }
    }
}

async function fetchOrderDetails(orderName, orderEmail) {
    const body = {
        orderName: orderName,
        orderEmail: orderEmail
    };

    const response = await fetch('/apps/api/orders/status/details', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(body),
    });

    if (!response.ok) {
        throw new Error('שגיאה בטעינת פרטי ההזמנה. אנא בדוק את הפרטים שהזנת ונסה שוב.');
    }

    const contentType = response.headers.get('content-type');
    if (!contentType || !contentType.includes('application/json')) {
        throw new Error('שגיאה בטעינת פרטי ההזמנה. אנא בדוק את הפרטים שהזנת ונסה שוב.');
    }

    const responseJson = await response.json();

    if (!responseJson.success) {
        throw new Error(responseJson.message || 'שגיאה בטעינת פרטי ההזמנה. אנא בדוק את הפרטים שהזנת ונסה שוב.');
    }

    if (!responseJson.statusChangeDates) {
        throw new Error('הזמנה לא נמצאה. אנא בדוק את כתובת המייל ומספר ההזמנה שהזנת.');
    }

    return responseJson;
}

function initTrackOrderFormHandler() {
    const trackOrderForm = document.getElementById('track-order-form');
    const errorMessage = document.getElementById('track-order-error-message');
    const errorText = errorMessage?.querySelector('p.note.form-error');
    const submitButton = document.getElementById('track-order-submit-button');
    const orderWrapper = document.querySelector('.boa-track-order-section .boa-order-wrapper');

    if (!trackOrderForm || !submitButton || !orderWrapper) {
        return;
    }

    trackOrderForm.addEventListener('submit', async (event) => {
        event.preventDefault();

        let errorMessageText = 'שגיאה בטעינת פרטי ההזמנה. אנא בדוק את הפרטים שהזנת ונסה שוב.';

        const spinner = submitButton.querySelector('.spinner');
        if (spinner) {
            spinner.classList.remove('hidden');
        }
        submitButton.disabled = true;
        submitButton.classList.add('loading');

        if (errorMessage) {
            errorMessage.classList.add('hidden');
        }

        const formData = new FormData(trackOrderForm);
        const orderEmail = formData.get('email');
        const orderName = formData.get('order_number');

        try {
            const responseJson = await fetchOrderDetails(orderName, orderEmail);
            const statusValue = buildOrderRow(responseJson, orderName);

            if (!statusValue) {
                throw new Error('שגיאה בטעינת פרטי ההזמנה. אנא בדוק את הפרטים שהזנת ונסה שוב.');
            }

            orderWrapper.classList.remove('hidden');

            const cancelledStatuses = ['96', '97'];
            if (!cancelledStatuses.includes(statusValue.toString())) {
                updatePizzabar(statusValue, responseJson.isPickup);
            }
        } catch (error) {
            orderWrapper.classList.add('hidden');

            if (error && error.message && error.message !== 'שגיאה בטעינת פרטי ההזמנה. אנא בדוק את הפרטים שהזנת ונסה שוב.' && error.message !== 'הזמנה לא נמצאה. אנא בדוק את כתובת המייל ומספר ההזמנה שהזנת.') {
                errorMessageText = error.message;
            }

            if (errorText) {
                errorText.textContent = errorMessageText;
            }

            if (errorMessage) {
                errorMessage.classList.remove('hidden');
            }
        } finally {
            spinner?.classList.add('hidden');
            submitButton.disabled = false;
            submitButton.classList.remove('loading');
        }
    });
}